import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as WinbeatIconSVG } from '@/assets/icons/Winbeat.svg';

export const WinbeatIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<WinbeatIconSVG />
		</SvgIcon>
	);
};
